import Icon from "../Icon";
import { FC, ReactElement, useRef, useEffect } from "react";

const FormSuccessMessage: FC<{scrollIntoView: boolean; children: ReactElement}> = ({scrollIntoView, children}) => {
	const ref = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (scrollIntoView && ref.current) {
			ref.current.scrollIntoView({ behavior: 'smooth' });
		}
}, [scrollIntoView, ref])

return <div className='text-center pt-20 flex flex-col justify-center items-center gap-20' ref={ref} role="alert">
	<Icon className="fi fi-br-check-circle text-[9rem] text-brand-main"></Icon>
	{children}
</div>;}

export default FormSuccessMessage;